import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "targetDetails" }

import {useStore} from "vuex";
import {useRoute} from 'vue-router';
import {UserActions, UserGetters} from "@/store/modules/user";
import {computed, onMounted, ref} from "vue";


import TargetPanel from '@/components/target/TargetPanel.vue';
import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "TargetDetails",
    components: {
        TargetPanel,
    }
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const userInfo = computed(() => {
    return store.getters[`user/${UserGetters.getUserInfo}`];
});
const isLoading = computed(() => {
    return store.getters[`user/${UserGetters.getIsLoading}`];
});

const moduleList = ref<string>("")

onMounted(async () => {
  await store.dispatch(`user/${UserActions.asyncGetOwnInfo}`, {});

  moduleList.value = await store.dispatch(`user/${UserActions.asyncGetPanelList}`, {
      userId: userInfo.value.id,
      projId: projectId.value,
      uid: targetId.value
    })
})


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TargetPanel, { moduleList: moduleList.value }, null, 8, ["moduleList"])
  ])), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})